module.controller('blockFraudCtrl', ['$scope', '$http','baseURI', 'Transform', '$stateParams', '$window', 'Session', function($scope, $http,baseURI, Transform, $stateParams, $window, Session){

  var vm = this;
  var username = $stateParams.username;

  if ( username === null ) {
    username = Session.getUsername();
  }

  if( username ) {
    vm.netVerifyLink = true;
  }
  vm.netVerifyLink = true;
  vm.initiateNetVerify = function(){
    $http({
      method: 'POST',
      url: baseURI + 'cardholder/verification',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode({Username: username})
    }).then(function(resp){
      var data = resp.data;

      if(data.Success){
        var netVerify = JSON.parse(data.Data);
        $window.location = netVerify.clientRedirectUrl;
      }
    }).catch(function(e){
      console.log(e);
    });
  };

}]);
